import { Flex } from '@chakra-ui/react';
import React from 'react';
import GoalItem from './GoalItem';
import { Scrollbars } from 'react-custom-scrollbars-2';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useState } from 'react';
import { patchGoalItem } from '../../stores/slices/goals/goalsActions';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
// import { useSelector } from 'react-redux';

const Goals = ({ goals, category }) => {
  // const { categories } = useSelector(state => state.goals);
  const [items, setItems] = useState(
    [...goals].sort((a, b) => a.order - b.order)
  );

  const dispatch = useDispatch();
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  useEffect(() => {
    setItems([...goals].sort((a, b) => a.order - b.order));
  }, [goals]);

  return (
    <React.Fragment>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <Scrollbars>
          <Flex overflowY="auto" flexDirection="column" flex={1} w={'full'}>
            <SortableContext
              items={items}
              strategy={verticalListSortingStrategy}
            >
              {items.map((goal, i) => (
                <GoalItem goal={goal} i={i} category={category} key={goal.id} />
              ))}
            </SortableContext>
          </Flex>
        </Scrollbars>
      </DndContext>
    </React.Fragment>
  );
  function handleDragEnd(event) {
    const { active, over } = event;

    if (active.id !== over.id) {
      setItems(items => {
        const oldIndex = items.findIndex(item => item.id === active.id);
        const newIndex = items.findIndex(item => item.id === over.id);
        saveOrder(active, newIndex);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }
  async function saveOrder(active, newIndex) {
    await dispatch(
      patchGoalItem({
        goalId: active.id,
        goal: {
          // order: newIndex,
          order_position: newIndex,
        },
      })
    );
  }
};

export default Goals;
